import React,{ useState, useEffect, useRef } from "react";
import { 
    Table,
    Button,
    Input,
    Space
} from 'antd';

import Highlighter from 'react-highlight-words';

import { 
    SearchOutlined,
    CheckCircleOutlined
} from '@ant-design/icons';

function ChannelListingTable({
    channelObjects,
    channelsLoading
}) {
    const [channelTableData, setChannelTableData] = useState( [] );
    const [sortedInfo, setSortedInfo] = useState( {} );
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [filteredInfo, setFilteredInfo] = useState({});
    const siteDomain = headerVars.siteDomain;
    const themePath = headerVars.themeURI;

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{ padding: 8}}
                onKeyDown={(e) => e.stopPropagation()}
            >
            <Input
                ref={searchInput}
                placeholder={`Search channels`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{
                    marginBottom: 8,
                    display: 'block',
                }}
            />
            <Space>
                <Button
                    type="primary"
                    className="table-search-filter-btn"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90
                    }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => clearFilters && handleReset(clearFilters)}
                    size="small"
                    className="table-search-reset-btn"
                    style={{
                        width: 90,
                    }}
                >
                    Reset
                </Button>
                {/*<Button
                    type="link"
                    size="small"
                    onClick={() => {
                        confirm({
                            closeDropdown: false,
                        });
                        setSearchText(selectedKeys[0]);
                        setSearchedColumn(dataIndex);
                    }}
                >
                Filter
                </Button> */}
                <Button
                    type="link"
                    size="small"
                    className="table-search-reset-btn"
                    onClick={() => {
                        close();
                    }}
                >
                    close
                </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined
            style={{
              color: filtered ? '#1677ff' : undefined,
            }}
          />
        ),
        onFilter: (value, record) =>
          record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });

    const columns = [ {
            title: '#',
            dataIndex: 'channelNumber',
            key: 'channelNumber',
            sorter: (a, b) => a.channelNumber - b.channelNumber,
            sortOrder: sortedInfo.columnKey === 'channelNumber' ? sortedInfo.order : null,
        },{
            title: '',
            dataIndex: 'channel',
            key: 'channel',
        },{
            title: 'Channel name',
            dataIndex: 'channelName',
            //hidden: true,
            key: 'channelName',
            ...getColumnSearchProps('channelName'),
            sorter: (a, b) => a.channelName.localeCompare(b.channelName),
            sortOrder: sortedInfo.columnKey === 'channelName' ? sortedInfo.order : null,
        },{
            title: 'Light',
            dataIndex: 'light',
            key: 'light',
            responsive: ['sm'],
            filters: [{
                    text: 'Included in the Light package',
                    value: "yes",
                }
            ],
            onFilter: (value, record) => record.light !== '',
        },{
            title: 'Premium',
            dataIndex: 'premium',
            key: 'premium',
            responsive: ['sm'],
            filters: [{
                text: 'Included in the Premium package',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.premium !== '',
        },{
            title: 'Ultimate',
            dataIndex: 'ultimate',
            key: 'ultimate',
            responsive: ['sm'],
            filters: [{
                text: 'Included in the Ultimate package',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.ultimate !== '',
        },{
            title: 'Resolution',
            dataIndex: 'resolution',
            key: 'resolution',
            responsive: ['md'],
            filters: [{
                text: 'Channels in HD',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.resolution !== '',
        },{
            title: 'Wifi',
            dataIndex: 'wifi',
            key: 'wifi',
            responsive: ['xl'],
            filters: [{
                text: 'Available in browser',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.wifi !== '',
        },{
            title: 'Pause',
            dataIndex: 'pause',
            key: 'pause',
            responsive: ['xl'],
            filters: [{
                text: 'Includes Pause',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.pause !== '',
        },{
            title: 'Restart',
            dataIndex: 'restart',
            key: 'restart',
            responsive: ['xl'],
            filters: [{
                text: 'Includes Restart',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.restart !== '',
        },{
            title: 'Lookback',
            dataIndex: 'lookback',
            key: 'lookback',
            responsive: ['xl'],
            filters: [{
                text: 'Includes lookback',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.lookback !== '',
        },{
            title: 'PVR',
            dataIndex: 'pvr',
            key: 'pvr',
            responsive: ['xl'],
            filters: [{
                text: 'Includes PVR',
                value: "yes",
            }
            ],
            onFilter: (value, record) => record.pvr !== '',
        }
    ].filter(item => !item.hidden);

    useEffect(() => {
        let channelData = [];
        let checkImgSrc = themePath + "/images/Res_StartTV-ChannelInfo_Check_12.png";
        let infoImgSrc = themePath + "/images/Res_StartTV-ChannelInfo_Info_12.png";

        for( let i=0; i < channelObjects.length; i++ ) {

            let dirtyDescription = channelObjects[i].content;
            var div = document.createElement("div");
            div.innerHTML = dirtyDescription;
            let cleanDescription = div.innerText;
            let includedThemes = channelObjects[i].themes;
            
            //console.log( "cleanDescription:: ", cleanDescription );


            let channelRow = {
                channelNumber: channelObjects[i].channel,
                channelName: channelObjects[i].title,
                channel: <img style={{ width:'50px', minWidth:'50px' }} src={ channelObjects[i].logo } />,
                light: ( channelObjects[i].light == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                premium: ( channelObjects[i].premium == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                ultimate: ( channelObjects[i].ultimate == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                themes: ( channelObjects[i].themes != '' ) ? <img style={{ width:'25px' }} src={ infoImgSrc } /> : '',
                resolution: channelObjects[i].resolution,
                wifi: ( channelObjects[i].wifi == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                pause: ( channelObjects[i].pause == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                restart: ( channelObjects[i].restart == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                lookback: ( channelObjects[i].lookback == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                pvr: ( channelObjects[i].pvr == 'yes' ) ? <img style={{ width:'25px' }} src={ checkImgSrc } /> : '',
                description: getChannelRowDescription( 
                    channelObjects[i].logo,
                    cleanDescription,
                    includedThemes,
                    channelObjects[i].light,
                    channelObjects[i].premium,
                    channelObjects[i].ultimate,
                    channelObjects[i].resolution,
                    channelObjects[i].wifi,
                    channelObjects[i].pause,
                    channelObjects[i].restart,
                    channelObjects[i].lookback,
                    channelObjects[i].pvr,
                )
            }

            channelData.push( channelRow );
        }

        //console.log( 'channelData:: ', channelData );

        setChannelTableData( channelData );

    }, [ channelObjects ]);

    const getChannelRowDescription = ( 
        logo,
        cleanDescription,
        includedThemes,
        inLight,
        inPremium,
        inUltimate,
        isHD,
        isWifi,
        isPause,
        isRestart,
        isLookback,
        isPvr
        ) => {
        
            let lightIncluded = ( inLight !== '' ) ? <div><CheckCircleOutlined /> Included in the light package.</div> : <></>;

            let premiumIncluded = ( inPremium !== '' ) ? <div><CheckCircleOutlined /> Included in the premium package.</div> : <></>;

            let ultimateIncluded = ( inUltimate !== '' ) ? <div><CheckCircleOutlined /> Included in the ultimate package.</div> : <></>;

            let channelResolution = ( isHD !== '' ) ? <div><CheckCircleOutlined /> Available in HD.</div> : <></>;

            let wifiEnabled = ( isWifi !== '' ) ? <div><CheckCircleOutlined /> Available in a browser.</div> : <></>;

            let pauseEnabled = ( isPause !== '' ) ? <div><CheckCircleOutlined /> Pause enabled.</div> : <></>;

            let restartEnabled = ( isRestart !== '' ) ? <div><CheckCircleOutlined /> Restart enabled.</div> : <></>;

            let lookbackEnabled = ( isLookback !== '' ) ? <div><CheckCircleOutlined /> Lookback enabled.</div> : <></>;

            let pvrEnabled = ( isPvr !== '' ) ? <div><CheckCircleOutlined /> PVR enabled.</div> : <></>;


        return(
            <div className="channel-listing-row-description-container">
                <div className="channel-listing-row-description">
                    <img style={{ width:'100px' }} src={ logo } />
                    <div>
                        <p>{ cleanDescription }</p>
                        <p>{ includedThemes }</p>
                        <div className="channel-listing-row-mobile-details">
                            { lightIncluded }
                            { premiumIncluded }
                            { ultimateIncluded }
                            { channelResolution }
                            { wifiEnabled }
                            { pauseEnabled }
                            { restartEnabled }
                            { lookbackEnabled }
                            { pvrEnabled }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const handleTableColumnChange = ( pagination, filters, sorter ) => {
        //console.log('Various parameters', pagination, filters, sorter);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters({confirm: true});
        setSearchText('');
    };

    const clearFilters = () => {
        setFilteredInfo({});
    };

    return (
        
        <div className="channel-listing-table-container">
            <Table 
                columns={ columns } 
                dataSource={ channelTableData }
                loading={ channelsLoading }
                sortDirections={["descend", "ascend"]}
                rowKey={ ( record ) => ( record.channelNumber ) }
                size={ 'small' }
                expandable={{
                    expandedRowRender: (record) => (
                      <p style={{ maxWidth: '600px' }}>{record.description}</p>
                    )
                }}
                onChange={handleTableColumnChange}
            />
        </div>
    )
}

export default ChannelListingTable